import _styledstyled_components from 'styled-components';
            const _styled = typeof _styledstyled_components.default === 'undefined' ? _styledstyled_components : _styledstyled_components.default;;
import React, { forwardRef } from 'react';
import { createPortal } from 'react-dom';
const SlidePortal = forwardRef(({
  container = document.body,
  ...rest
}, ref) => {
  return createPortal(<_StyledDiv ref={ref} {...rest} />, container);
});
SlidePortal.displayName = 'SlidePortal';
export default SlidePortal;
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-1ab9qfp-0"
})({
  "position": "fixed",
  "top": "0px",
  "left": "0px",
  "zIndex": "50",
  "height": "100%",
  "width": "100%",
  "touchAction": "none",
  "overflow": "hidden"
});